import { computed } from "vue";
import { ELinkListElements } from "../types.js";
import useCreateComponentConfig, { EStates } from "../../../composables/useCreateComponentConfig.js";
import { SIZES } from "@/ui/ts/types/Sizes";
import focus from "@/ui/plushComponents/constants/focus";
export default function useLinkListConfig(props) {
  const rootClasses = useRootConfig(props);
  const labelClasses = useLabelConfig(props);
  const descriptionClasses = useDescriptionConfig(props);
  return {
    root: rootClasses,
    label: labelClasses,
    description: descriptionClasses
  };
}
function useRootConfig(props) {
  const { getClasses, addBaseState, setBase } = useCreateComponentConfig();
  setBase(
    ELinkListElements.ROOT,
    /* tw */
    `flex w-full cursor-pointer flex-row gap-2 text-left transition-colors duration-200 ${props.hasDivider ? "py-base" : "py-xs"} ${props.size === SIZES.MEDIUM ? "label-md" : "label-lg"}`
  );
  addBaseState(
    ELinkListElements.ROOT,
    EStates.DEFAULT,
    /* tw */
    `text-comp-high-contrast`
  );
  addBaseState(
    ELinkListElements.ROOT,
    EStates.HOVER,
    /* tw */
    `hover:text-neutral-tertiary`
  );
  addBaseState(
    ELinkListElements.ROOT,
    EStates.PRESSED,
    /* tw */
    `active:text-comp-high-contrast`
  );
  addBaseState(
    ELinkListElements.ROOT,
    EStates.FOCUSED,
    /* tw */
    `${focus}`
  );
  addBaseState(
    ELinkListElements.ROOT,
    EStates.DISABLED,
    /* tw */
    `!text-disabled pointer-events-none`
  );
  const classes = computed(() => {
    return getClasses(ELinkListElements.ROOT, void 0, props.size, props.state, props.disabled);
  });
  return classes.value;
}
function useLabelConfig(props) {
  const { getClasses, addSize, setBase } = useCreateComponentConfig();
  setBase(
    ELinkListElements.LABEL,
    /* tw */
    `line-clamp-3`
  );
  addSize(
    ELinkListElements.LABEL,
    SIZES.MEDIUM,
    /* tw */
    `label-md`
  );
  addSize(
    ELinkListElements.LABEL,
    SIZES.LARGE,
    /* tw */
    `label-lg`
  );
  const classes = computed(() => {
    return getClasses(ELinkListElements.LABEL, void 0, props.size);
  });
  return classes.value;
}
function useDescriptionConfig(props) {
  const { getClasses, addBaseState, setBase } = useCreateComponentConfig();
  setBase(
    ELinkListElements.DESCRIPTION,
    /* tw */
    `paragraph-sm line-clamp-3`
  );
  addBaseState(
    ELinkListElements.DESCRIPTION,
    EStates.DEFAULT,
    /* tw */
    `text-neutral-tertiary`
  );
  addBaseState(
    ELinkListElements.DESCRIPTION,
    EStates.DISABLED,
    /* tw */
    `!text-disabled`
  );
  const classes = computed(() => {
    return getClasses(ELinkListElements.DESCRIPTION, void 0, props.size, props.state, props.disabled);
  });
  return classes.value;
}
